import request from '@/utils/request'

// 获取积分指标列表
export function getIndicatorsList(params) {
  return request({
    url: '/indicators',
    method: 'get',
    params
  })
}

// 提交积分申请
export function submitScoreApplication(data) {
  return request({
    url: '/points/report',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 获取积分上报类别
export function getScoreCategories() {
  return request({
    url: '/points/categories',
    method: 'get'
  })
}

// 获取积分子类别
export function getScoreSubCategories(categoryId) {
  return request({
    url: `/points/subcategories/${categoryId}`,
    method: 'get'
  })
}

// 获取待审核积分列表
export function getPendingScores(params) {
  return request({
    url: '/points/pending',
    method: 'get',
    params
  })
}

// 获取审核统计数据
export function getReviewStatistics() {
  return request({
    url: '/points/review-statistics',
    method: 'get'
  })
}

// 审核积分申请
export function reviewScore(id, data) {
  return request({
    url: `/points/${id}`,
    method: 'patch',
    data
  })
}

// 获取积分详情
export function getScoreDetail(id) {
  return request({
    url: `/points/detail/${id}`,
    method: 'get'
  })
}

// 获取积分排名
export function getScoreRanking(params) {
  return request({
    url: '/ranks',
    method: 'get',
    params
  })
}

// 获取部门列表
export function getDepartments() {
  return request({
    url: '/departments',
    method: 'get'
  })
}

// 获取排名前三
export function getTopThree(params) {
  return request({
    url: '/ranks/top',
    method: 'get',
    params
  })
}

// 导出排名
export function exportRanking(params) {
  return request({
    url: '/ranks/export',
    method: 'get',
    params,
    responseType: 'blob'
  })
}

// 获取积分分布数据（用于图表展示）
export function getScoreDistribution(params) {
  return request({
    url: '/stats/distribution',
    method: 'get',
    params
  })
} 